import buildCorrectGrammarText from "Common/componentUtils/buildCorrectGrammarText";
export default {
    buildCountTasksTitle: (count) => `${count} ${buildCorrectGrammarText(count, ["задача", "задачи", "задач"])}`,
    TASK_NAME: "Название задания",
    SEARCH_CRITERIA: "Критерии поиска",
    METHOD: "Метод",
    CREATED: "Создана",
    DURATION: "Длительность",
    AUTHOR: "Автор",
    DOCUMENT: "Документ",
    WATCH_TASK_LOGS: "Посмотреть лог задания",
    FILTER_TEXT: "Поиск..."
};
